// 按需引入Vant组件（Button按钮、Field输入框、Toast轻提示）
import Vue from 'vue'
import { Button, Field, Toast, Icon, Popup, List } from 'vant'

// 注册Vant组件到全局
Vue.use(Button) // 按钮组件
Vue.use(Field) // 输入框组件
Vue.use(Toast) // 轻提示组件
Vue.use(Icon) // 注册Icon组件
Vue.use(Popup) // 注册Popup（弹出层）组件
Vue.use(List) // 注册List组件
